import styled from 'styled-components';
import Card from '@components/CardContainer';

const StyledCard = styled(Card)`
  display: flex;
  position: relative;
  cursor: pointer;
  width: 100%;
  max-width: 231px;
  height: 100%;
  max-height: 85px;
  padding: 0;
  border-radius: 6px;
`;

export default StyledCard;
